<template>
  <div class="cpt-radio-row" :class="{ active: active , reverse: reverse}" @click="$emit('click')">
    <template v-if="!reverse">
      <div class="text" :class="{ bold: is_bold }">
        <p
          v-tooltip="{ text: label, autoEllipsis: true }"
          v-if="isTooptip"
          v-html="label"
        ></p>
        <p v-else v-html="label"></p>
        <p class="desc" v-if="desc">{{ desc }}</p>
      </div>
      <i class="iconfont radio-icon" :class="icon" v-if="icon"></i>
      <div class="radio" v-else></div>
    </template>
    <template v-else>
      <i class="iconfont radio-icon" :class="icon" v-if="icon"></i>
      <div class="radio" v-else></div>
      <div class="text" :class="{ bold: is_bold }">
        <p
          v-tooltip="{ text: label, autoEllipsis: true }"
          v-if="isTooptip"
          v-html="label"
        ></p>
        <p v-else v-html="label"></p>
        <p class="desc" v-if="desc">{{ desc }}</p>
      </div>
      <i class="iconfont icon-arrow-left arrow-menu-icon" v-if="is_sub_menu"></i>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
    },
    is_bold: {
      default: false,
    },
    reverse: {
      default: false
    },
    desc: {
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    isTooptip: {
      default: false,
      type: Boolean
    },
    is_sub_menu: {
      default: false,
      type: Boolean
    }
  },
};
</script>

<style lang="scss">
.cpt-radio-row {
  width: 100%;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: $d-tx-2;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .text {
    width: 0;
    flex: 1;
  }
  .radio {
    width: 16px;
    height: 16px;
    border: 2px solid $d-op-3;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .radio-icon {
    margin-left: 6px;
    width: 16px;
    height: 16px;
    font-size: 16px;
  }
  &.active {
    .text{
      &.bold {
        font-weight: 700;
        color: $d-tx-1;
      }
    }
    .radio-icon {
      color: $d-bd-tx;
    }
    .radio {
      border: 2px solid $d-bd-tx !important;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: $d-bd-tx;
        border-radius: 50%;
      }
    }
  }
  &.reverse {
    .radio {
      margin-right: 6px;
    }
    .radio-icon {
      margin-right: 6px;
      margin-left: 0;
    }
  }
  .text {
    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .desc {
      color: $d-op-4;
      font-size: 12px;
      line-height: 12px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .arrow-menu-icon {
    width: 6px;
    height: 6px;
    color: $d-tx-3;
    &::before {
      width: 12px;
      height: 12px;
      font-size: 12px;
      transform: scale(.5);
    }
  }
}
</style>
